import { Component } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  standalone: true,
  selector: 'hk-centered-mat-spinner',
  template: `
    <mat-spinner></mat-spinner>
  `,
  styles: [
    `
      :host {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999;
        display: flex;
        width: 100%;
        height: 100%;
        justify-content: center;
        align-items: center;
        background-color: rgba(0, 0, 0, 0.4);
      }

      /*noinspection CssUnusedSymbol*/
      mat-spinner.mat-mdc-progress-spinner {
        display: flex;
      }
    `,
  ],
  imports: [MatProgressSpinner],
})
export class CenteredMatSpinnerComponent {}
